// extracted by mini-css-extract-plugin
export var authorBioStyle = "blog_post_footer-module--authorBioStyle--XpyrA";
export var authorHeadingWrapperStyle = "blog_post_footer-module--authorHeadingWrapperStyle--O8D7j";
export var authorJobTitleStyle = "blog_post_footer-module--authorJobTitleStyle--sL1cS";
export var authorStyle = "blog_post_footer-module--authorStyle--juoCr";
export var avatarWrapperStyle = "blog_post_footer-module--avatarWrapperStyle--Q0nbq";
export var footerStyle = "blog_post_footer-module--footerStyle--XKq+s";